import React from "react";
import { Col, Layout, Row } from "antd";
import classNames from "classnames";
import get from "lodash/get";
import { connect } from "react-redux";

import Footer from "../../components/Footer/Footer";
import ConsentForm from "../../components/ConsentError/ConsentFormError";

import { getConsentData } from "../../reducers/consent/selectors";
import { consentUpdate } from "../../reducers/consent/actions";

import classes from "./ConsentError.css";
import { Helmet } from "react-helmet";

import { withNamespaces } from "react-i18next";

const { Content } = Layout;

class Consent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: {},
    };
  }

  render() {
    const token = get(this.props, "match.params.token");

    return (
      <div>
        <Helmet>
          <title>{this.props.i18n.t('NamespaceConsent:Trial Management Portal')}: {this.props.i18n.t('NamespaceConsent:Consent')}</title>
        </Helmet>
        <div className={classes.wrapper}>

          <div className={classes.content}>
            <Layout className={classes.parentContainer}>
              <Content className={classes.content}>
                <Row>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 20, offset: 2 }}
                    md={{ span: 16, offset: 4 }}
                    style={{ paddingTop: "4rem" }}
                  >

                    <Row type="flex" justify="center">
                      <Col
                        className={classNames(
                        )}
                        xs={24}
                        sm={18}
                        md={18}
                        lg={20}
                        xl={22}
                        style={{ marginBottom: "36px" }}
                      >
                        <ConsentForm history={this.props.history} />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Content>
            </Layout>
          </div>
          <div style={{ marginTop: 'auto' }}>

          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  consentData: getConsentData(state),
});

const mapDispatchToProps = { consentUpdate };

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Consent));



// WEBPACK FOOTER //
// ./src/containers/ConsentError/ConsentError.js